export enum MedicationTypes {
    PREANESTHETIC_SEDATIVE_MEDICATIONS = 1,
    ANESTHETIC_INDUCTION_MEDICATIONS = 2,
    CONSTANT_RATE_INFUSION = 3,
    ADDITIONAL_MEDICATIONS = 4
}
